import { HOST_TYPES } from "store/types";
import { generateCSV_hostData, refactorHostsObj } from "utils/misc";

const initialState = {
  hosts: [],
  totalCount: 0,
  currentPage: 1,
  loading: false,
  hostDetails: null,
};

const hostReducer = (state = initialState, action) => {
  switch (action.type) {
    case HOST_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };

    case HOST_TYPES.SET_HOST:
      return {
        ...state,
        hosts: action.payload.results,
        totalCount: action.payload.count,
        currentPage: action.payload.page,
      };

    case HOST_TYPES.FETCH_HOST_DETAILS_SUCCESS:
      return { ...state, hostDetails: action.payload };

    default:
      return state;
  }
};

export default hostReducer;
